import { render, staticRenderFns } from "./TreatmentInstruction.vue?vue&type=template&id=75a10df2&scoped=true&lang=pug&"
import script from "./TreatmentInstruction.vue?vue&type=script&lang=js&"
export * from "./TreatmentInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a10df2",
  null
  
)

export default component.exports